import { Box } from "@mui/material";
import styled from "@emotion/styled";
import {
  PatientAttributes,
  RequestType,
  requestTypeExtendedTranslation,
} from "../../../interfaces";
import {
  CardInfoText,
  CardSectionSubtitle,
  GappedCardContainer,
  StyledLink,
} from "../styles";
import { ObscuredText } from "@components";
import { format as formatDate } from "date-fns";

type Props = {
  documentType: RequestType;
  emissionDate: Date;
  patientData: Omit<PatientAttributes, "phone">;
  medicalDocumentPDFReadUrl: string;
};

const DateContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  gap: "4px",
});

const DocumentTypeContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  gap: "4px",
});
export const GeneralInfoCard: React.FC<Props> = ({
  documentType,
  emissionDate,
  patientData,
  medicalDocumentPDFReadUrl,
}) => {
  return (
    <GappedCardContainer>
      <DocumentTypeContainer>
        <CardSectionSubtitle>Tipo de documento: </CardSectionSubtitle>
        <CardInfoText paddingTop={"0px"}>
          {requestTypeExtendedTranslation[documentType]}
        </CardInfoText>
      </DocumentTypeContainer>
      <DateContainer>
        <CardSectionSubtitle>Fecha emisión: </CardSectionSubtitle>
        <CardInfoText paddingTop={"0px"}>
          {formatDate(emissionDate, "dd/MM/yyyy")}
        </CardInfoText>
      </DateContainer>
      <Box>
        <CardSectionSubtitle>Datos paciente</CardSectionSubtitle>
        <ObscuredText component={CardInfoText}>
          {patientData.name} {patientData.firstSurname}{" "}
          {patientData.secondSurname}
        </ObscuredText>
        {patientData.documentNumber && (
          <ObscuredText component={CardInfoText}>
            {patientData.documentNumber}
          </ObscuredText>
        )}
      </Box>
      <Box>
        <CardInfoText>Documento emitido por MekiDoc</CardInfoText>
        {medicalDocumentPDFReadUrl && (
          <CardInfoText>
            <StyledLink
              color="primary"
              target="_blank"
              onClick={() => {
                window.open(medicalDocumentPDFReadUrl, "_blank");
              }}
            >
              Ver Documento Original
            </StyledLink>
          </CardInfoText>
        )}
      </Box>
    </GappedCardContainer>
  );
};
